import { LocaleEnum as e, localeNames as t } from "@systemeio/types";
//#region src/translations/locale-labels.ts
var n = {
	[e.ENGLISH]: "EN",
	[e.FRENCH]: "FR",
	[e.SPANISH]: "ES",
	[e.ITALIAN]: "IT",
	[e.PORTUGUESE]: "PT",
	[e.DEUTSCH]: "DE",
	[e.DUTCH]: "NL",
	[e.RUSSIAN]: "RU",
	[e.JAPANESE]: "JP",
	[e.ARABIC]: "AR",
	[e.TURKISH]: "TR",
	[e.CHINESE]: "CH",
	[e.SWEDISH]: "SV",
	[e.ROMANIAN]: "RO",
	[e.CZECH]: "CS",
	[e.HUNGARIAN]: "HU",
	[e.SLOVAK]: "SK",
	[e.DANISH]: "DK",
	[e.INDONESIAN]: "ID",
	[e.POLISH]: "PL",
	[e.GREEK]: "EL",
	[e.SERBIAN]: "SR",
	[e.HINDI]: "HI",
	[e.NORWEGIAN]: "NO",
	[e.THAI]: "TH",
	[e.SLOVENIAN]: "SL",
	[e.UKRAINIAN]: "UA",
	[e.ALBANIA]: "SQ"
}, r = t, i = {
	[e.ENGLISH]: "locale.english",
	[e.FRENCH]: "locale.french",
	[e.SPANISH]: "locale.spanish",
	[e.ITALIAN]: "locale.italian",
	[e.PORTUGUESE]: "locale.portuguese",
	[e.DEUTSCH]: "locale.german",
	[e.DUTCH]: "locale.dutch",
	[e.RUSSIAN]: "locale.russian",
	[e.JAPANESE]: "locale.japanese",
	[e.CHINESE]: "locale.chinese",
	[e.TURKISH]: "locale.turkish",
	[e.ARABIC]: "locale.arabic",
	[e.SWEDISH]: "locale.swedish",
	[e.ROMANIAN]: "locale.romanian",
	[e.CZECH]: "locale.czech",
	[e.HUNGARIAN]: "locale.hungarian",
	[e.SLOVAK]: "locale.slovak",
	[e.DANISH]: "locale.danish",
	[e.INDONESIAN]: "locale.indonesian",
	[e.POLISH]: "locale.polish",
	[e.GREEK]: "locale.greek",
	[e.SERBIAN]: "locale.serbian",
	[e.HINDI]: "locale.hindi",
	[e.NORWEGIAN]: "locale.norwegian",
	[e.THAI]: "locale.thai",
	[e.SLOVENIAN]: "locale.slovenian",
	[e.UKRAINIAN]: "locale.ukrainian",
	[e.ALBANIA]: "locale.albania"
};
//#endregion
export { n as localeLabels, i as localeLanguages, r as localeNames };
